/* Stayclose theme JS — gallery, reveal-on-scroll, variant price sync */
(function () {
  'use strict';

  /* Reveal on scroll */
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    document.querySelectorAll('.reveal').forEach(function (el) {
      observer.observe(el);
    });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  /* Product gallery.

     The photographs sit in a scroll-snap track, so a finger already moves
     between them with no JavaScript at all. This only keeps the thumbnails
     and the track pointing at the same photograph: a thumbnail scrolls the
     track, and a swipe marks the thumbnail. */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var thumbs = [].slice.call(gallery.querySelectorAll('[data-gallery-thumb]'));
    if (!thumbs.length) return;

    var track = gallery.querySelector('[data-gallery-track]');

    /* An older copy of the product section renders a single
       <img data-gallery-main> and parks the other photographs on the
       thumbnails as data-src. Build the track out of those, so the gallery
       swipes whether or not that one file is current — the stylesheet
       already lays this element out as the track, so there is nothing to
       style here. */
    if (!track) {
      var legacyMain = gallery.querySelector('[data-gallery-main]');
      var frame = legacyMain && legacyMain.parentNode;
      var sources = thumbs.map(function (t) {
        return { src: t.getAttribute('data-src'), alt: t.getAttribute('data-alt') || '' };
      }).filter(function (s) { return s.src; });

      if (frame && sources.length > 1) {
        frame.innerHTML = '';
        sources.forEach(function (s, i) {
          var img = document.createElement('img');
          img.src = s.src;
          img.alt = s.alt;
          if (i) img.loading = 'lazy';
          frame.appendChild(img);
        });
        frame.setAttribute('data-gallery-track', '');
        frame.setAttribute('tabindex', '0');
        frame.setAttribute('role', 'region');
        frame.setAttribute('aria-label', 'Product photographs, swipe to browse');
        track = frame;
      }
    }

    var slides = track ? [].slice.call(track.children) : [];

    function mark(index) {
      thumbs.forEach(function (t, i) {
        t.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    }

    /* One photograph, or markup we do not recognise. Swap it the old way
       rather than leaving the thumbnails dead, which is what bailing out
       here did the last time these two files went out of step. */
    if (!slides.length) {
      var main = gallery.querySelector('[data-gallery-main]');
      thumbs.forEach(function (thumb, index) {
        thumb.addEventListener('click', function () {
          var src = thumb.getAttribute('data-src');
          if (main && src) {
            main.src = src;
            main.alt = thumb.getAttribute('data-alt') || '';
          }
          mark(index);
        });
      });
      return;
    }

    thumbs.forEach(function (thumb, index) {
      thumb.addEventListener('click', function () {
        var slide = slides[index];
        if (!slide) return;
        /* scrollLeft rather than scrollIntoView: the latter would also drag
           the page vertically to bring the gallery into view. */
        track.scrollTo({
          left: slide.offsetLeft - track.offsetLeft,
          behavior: prefersReducedMotion() ? 'auto' : 'smooth'
        });
        mark(index);
      });
    });

    /* Which slide is showing after a swipe. Whichever one covers the middle
       of the track wins, which is what the snap has settled on. */
    var settling;
    track.addEventListener('scroll', function () {
      clearTimeout(settling);
      settling = setTimeout(function () {
        var middle = track.scrollLeft + track.clientWidth / 2;
        var nearest = 0;
        var best = Infinity;
        slides.forEach(function (slide, i) {
          var centre = slide.offsetLeft - track.offsetLeft + slide.clientWidth / 2;
          var gap = Math.abs(centre - middle);
          if (gap < best) { best = gap; nearest = i; }
        });
        mark(nearest);
      }, 90);
    }, { passive: true });
  });

  function prefersReducedMotion() {
    return !!(window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  /* Variant select → price + hidden id sync */
  document.querySelectorAll('[data-product-form]').forEach(function (wrapper) {
    var select = wrapper.querySelector('[data-variant-select]');
    var idInput = wrapper.querySelector('input[name="id"]');
    var priceEl = wrapper.querySelector('[data-price]');
    var button = wrapper.querySelector('[data-add-button]');
    if (!select) return;
    select.addEventListener('change', function () {
      var opt = select.options[select.selectedIndex];
      if (idInput) idInput.value = opt.value;
      if (priceEl && opt.dataset.price) priceEl.textContent = opt.dataset.price;
      if (button) {
        var available = opt.dataset.available === 'true';
        button.disabled = !available;
        button.textContent = available
          ? button.getAttribute('data-label-add')
          : button.getAttribute('data-label-soldout');
      }
    });
  });

  /* ---------- Cart drawer ----------------------------------------------
     Adding to the cart used to leave the page for /cart, which throws away
     everything the shopper was reading. The add is done over the API instead
     and the drawer slides in over it.

     Everything degrades: the header cart is still a link to /cart and the form
     is still a form, so with JavaScript off both behave as they always did. */
  var drawer = document.querySelector('[data-cart-drawer]');
  if (drawer) {
    var panel = drawer.querySelector('.cart-drawer__panel');
    var itemsEl = drawer.querySelector('[data-cart-items]');
    var footEl = drawer.querySelector('[data-cart-foot]');
    var subtotalEl = drawer.querySelector('[data-cart-subtotal]');
    var checkoutTotalEl = drawer.querySelector('[data-cart-total]');
    var moneyFormat = drawer.getAttribute('data-money-format') || '${{amount}}';
    var lastFocused = null;

    /* Shopify's money_format is a template, not a currency code, so the shop's
       own separators and decimals are honoured rather than assuming dollars. */
    function formatMoney(cents) {
      var placeholder = /\{\{\s*(\w+)\s*\}\}/;
      var match = moneyFormat.match(placeholder);
      var name = match ? match[1] : 'amount';
      var decimals = name.indexOf('no_decimals') > -1 ? 0 : 2;
      var comma = name.indexOf('comma_separator') > -1;
      var thousands = comma ? '.' : ',';
      var point = comma ? ',' : '.';
      var parts = (cents / 100).toFixed(decimals).split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return moneyFormat.replace(placeholder, whole + (parts[1] ? point + parts[1] : ''));
    }

    function escapeHtml(text) {
      return String(text).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function lineMarkup(item, index) {
      var titles = (item.line_level_discount_allocations || [])
        .map(function (d) { return d.discount_application.title; });
      var discounts = titles.map(function (t) {
        return '<span class="cart-line__discount">' + escapeHtml(t) + '</span>';
      }).join('');

      /* Bundle variants are often named after the deal, so the variant line and
         the discount badge end up saying the same thing twice. Show it once. */
      var named = item.variant_title
        && item.variant_title !== 'Default Title'
        && titles.indexOf(item.variant_title) === -1;
      var variant = named
        ? '<p class="cart-line__variant">' + escapeHtml(item.variant_title) + '</p>' : '';

      var price = item.original_line_price > item.final_line_price
        ? '<s>' + formatMoney(item.original_line_price) + '</s>' + formatMoney(item.final_line_price)
        : formatMoney(item.final_line_price);

      return '' +
        '<div class="cart-line" data-line="' + (index + 1) + '">' +
          '<div class="cart-line__media">' +
            (item.image ? '<img src="' + escapeHtml(item.image) + '" alt="" width="68" height="68" loading="lazy">' : '') +
          '</div>' +
          '<div>' +
            '<p class="cart-line__title">' + escapeHtml(item.product_title) + '</p>' +
            variant + discounts +
            '<div class="cart-line__foot">' +
              '<span class="cart-qty">' +
                '<button type="button" data-qty="-1" aria-label="Reduce quantity">&minus;</button>' +
                '<span>' + item.quantity + '</span>' +
                '<button type="button" data-qty="1" aria-label="Increase quantity">+</button>' +
              '</span>' +
              '<span class="cart-line__price">' + price + '</span>' +
            '</div>' +
            '<button type="button" class="cart-line__remove" data-remove>Remove</button>' +
          '</div>' +
        '</div>';
    }

    function paint(cart) {
      var count = cart.item_count || 0;
      if (!count) {
        /* the way back out belongs here, where it is the only thing left to do */
        itemsEl.innerHTML =
          '<div class="cart-drawer__empty">' +
            '<p>Nothing here yet.</p>' +
            '<button type="button" class="cart-drawer__continue" data-cart-close>Keep looking</button>' +
          '</div>';
        footEl.hidden = true;
      } else {
        itemsEl.innerHTML = cart.items.map(lineMarkup).join('');
        subtotalEl.textContent = formatMoney(cart.total_price);
        if (checkoutTotalEl) checkoutTotalEl.textContent = formatMoney(cart.total_price);
        footEl.hidden = false;
      }

      /* keep the header badge in step */
      var link = document.querySelector('[data-cart-toggle]');
      if (link) {
        var badge = link.querySelector('.site-header__cart-count');
        if (count) {
          if (!badge) {
            badge = document.createElement('span');
            badge.className = 'site-header__cart-count';
            link.appendChild(badge);
          }
          badge.textContent = count;
        } else if (badge) {
          badge.remove();
        }
      }
    }

    function refresh() {
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(paint)
        .catch(function () {
          itemsEl.innerHTML = '<p class="cart-drawer__empty">The cart could not be loaded. ' +
            '<a href="/cart">Open it here</a>.</p>';
        });
    }

    function open() {
      lastFocused = document.activeElement;
      drawer.hidden = false;
      /* a frame between unhiding and animating, or the transition is skipped */
      requestAnimationFrame(function () {
        drawer.classList.add('is-open');
        document.body.classList.add('cart-open');
        panel.focus();
      });
    }

    function close() {
      drawer.classList.remove('is-open');
      document.body.classList.remove('cart-open');
      if (lastFocused && lastFocused.focus) lastFocused.focus();
      var done = function () { drawer.hidden = true; };
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) done();
      else setTimeout(done, 360);
    }

    function change(line, quantity) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      }).then(function (r) { return r.json(); }).then(paint);
    }

    drawer.addEventListener('click', function (event) {
      if (event.target.closest('[data-cart-close]')) { close(); return; }

      var row = event.target.closest('[data-line]');
      if (!row) return;
      var line = parseInt(row.getAttribute('data-line'), 10);
      var shown = parseInt(row.querySelector('.cart-qty span').textContent, 10);

      if (event.target.closest('[data-remove]')) { change(line, 0); return; }
      var step = event.target.closest('[data-qty]');
      if (step) change(line, Math.max(0, shown + parseInt(step.getAttribute('data-qty'), 10)));
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && drawer.classList.contains('is-open')) close();
      /* hold the tab ring inside the panel while it is open */
      if (event.key === 'Tab' && drawer.classList.contains('is-open')) {
        var focusable = panel.querySelectorAll('a[href], button:not([disabled]), [tabindex="0"]');
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }
    });

    var toggle = document.querySelector('[data-cart-toggle]');
    if (toggle) {
      toggle.addEventListener('click', function (event) {
        event.preventDefault();
        open();
        refresh();
      });
    }

    /* The add-to-cart form is submitted over the API so the page stays put.
       The whole form is forwarded rather than a hand-built payload, so the
       hidden fields a bundle app writes into it travel along untouched. */
    document.querySelectorAll('[data-product-form] form').forEach(function (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var button = form.querySelector('[data-add-button]');
        if (button) button.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: new FormData(form)
        })
          .then(function (r) { return r.json().then(function (body) { return { ok: r.ok, body: body }; }); })
          .then(function (result) {
            if (!result.ok) throw new Error(result.body.description || 'Could not add to cart');
            open();
            return refresh();
          })
          .catch(function () {
            /* if the API refuses, fall back to the ordinary form post */
            form.submit();
          })
          .then(function () { if (button) button.disabled = false; });
      });
    });
  }

  /* Play the how-to video when its section is reached, pause it when it leaves.
     Starting it on page load would mean it had already looped several times by
     the time anyone scrolled to it. Muted, because browsers refuse to start
     anything audible unasked, and the file has no sound anyway.

     Controls are left on deliberately: something that moves by itself for more
     than a few seconds needs a way to stop it. If someone does stop it, that
     choice sticks — scrolling past and back will not start it up again. */
  document.querySelectorAll('video[data-autoplay-in-view]').forEach(function (video) {
    var reduceMotion = window.matchMedia
      && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion || !('IntersectionObserver' in window)) return;

    video.addEventListener('pause', function () {
      if (video.pausedByScroll) {
        video.pausedByScroll = false;
      } else {
        video.pausedByViewer = true;
      }
    });

    new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            if (video.pausedByViewer) return;
            var started = video.play();
            /* A browser can still refuse; the controls remain either way. */
            if (started && started.catch) started.catch(function () {});
          } else if (!video.paused) {
            video.pausedByScroll = true;
            video.pause();
          }
        });
      },
      { threshold: 0.4 }
    ).observe(video);
  });

  /* The buy-box price is a fixed figure set in the theme editor, so nothing
     rewrites it. The Kaching deal-bar price sync that used to live here was
     removed with it: the bundles still set the quantity and the price at
     checkout, they just no longer change the headline. */

  /* Countdown in the announcement bar.

     It counts to the one instant the theme editor was given and then stops.
     Nothing here restarts it, stores a per-visitor deadline, or falls back to
     "a few hours from now" — an evergreen timer is a lie about the offer, and
     this shop sells to people who have just lost an animal.

     A deadline already past never appears at all, rather than showing zeroes. */
  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    var endsAt = Date.parse(el.getAttribute('data-ends-at'));
    if (isNaN(endsAt)) return;

    /* A repeat rolls the target forward to the next occurrence, so the clock
       never runs out. It is worked out from the anchor date, in whole periods,
       so two people looking at once see the same deadline and reloading the
       page does not buy anyone more time. That is the whole difference between
       a recurring deadline and a fabricated one. */
    var repeatDays = parseInt(el.getAttribute('data-repeat-days') || '0', 10);
    if (repeatDays > 0) {
      var period = repeatDays * 86400000;
      var now = Date.now();
      if (endsAt <= now) {
        endsAt += Math.ceil((now - endsAt) / period) * period;
      }
    }

    var fields = {};
    el.querySelectorAll('[data-cd]').forEach(function (node) {
      fields[node.getAttribute('data-cd')] = node;
    });
    var summary = el.querySelector('[data-countdown-summary]');
    var lastSummary = '';

    function pad(n) { return n < 10 ? '0' + n : String(n); }

    function expire() {
      if (el.getAttribute('data-expiry') === 'hide-bar') {
        var bar = document.querySelector('[data-announcement]');
        if (bar) bar.hidden = true;
      }
      el.hidden = true;
    }

    function tick() {
      var left = endsAt - Date.now();
      if (left <= 0) { expire(); return false; }

      var seconds = Math.floor(left / 1000);
      var parts = {
        days: Math.floor(seconds / 86400),
        hours: Math.floor(seconds / 3600) % 24,
        minutes: Math.floor(seconds / 60) % 60,
        seconds: seconds % 60
      };
      Object.keys(parts).forEach(function (key) {
        if (fields[key]) fields[key].textContent = pad(parts[key]);
      });

      /* The digits are aria-hidden: a region rewriting itself every second is
         unusable read aloud. This says the same thing once a minute instead. */
      if (summary) {
        var coarse = parts.days + 'd ' + parts.hours + 'h ' + parts.minutes + 'm';
        if (coarse !== lastSummary) {
          lastSummary = coarse;
          summary.textContent = parts.days + ' days, ' + parts.hours +
            ' hours and ' + parts.minutes + ' minutes remaining';
        }
      }
      return true;
    }

    if (!tick()) return;
    el.hidden = false;
    var row = el.parentNode;
    if (row) row.classList.add('is-counting');
    var ticking = setInterval(function () {
      if (!tick()) clearInterval(ticking);
    }, 1000);
  });

  /* The closing offer's button, on a page that already carries the buy box.

     offer-cta.liquid emits href="#BuyBox" on a product page, so on a theme
     whose files are all current this needs no JavaScript at all. It is here
     because a theme can end up holding an older copy of one section file
     while everything around it is current, and then the anchor points at an
     id that is not on the page and the button goes back to reloading.
     Finding the buy box by class as well means one stale file cannot undo
     this.

     The href is still checked, so an offer deliberately pointing somewhere
     else is left to navigate. */
  var offerCta = document.querySelector('[data-offer-cta]');
  var buyBox = document.getElementById('BuyBox') || document.querySelector('.buybox');
  if (offerCta && buyBox) {
    var offerHref = offerCta.getAttribute('href') || '';
    var wantsScroll = offerHref === '' || offerHref === '#' ||
      offerHref.slice(-7) === '#BuyBox';
    if (wantsScroll) {
      offerCta.addEventListener('click', function (event) {
        event.preventDefault();
        buyBox.scrollIntoView({
          behavior: prefersReducedMotion() ? 'auto' : 'smooth',
          block: 'start'
        });
      });
    }
  }
})();
